export const formatDate = (dateString) => {
    if (!dateString || dateString === 'N/A') return dateString;
    try {
        const [day, month, year] = dateString.split('/');
        const date = new Date(year, month - 1, day);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${day}-${monthNames[date.getMonth()]}`;
    } catch (e) {
        return dateString;
    }
};

export const getPromotionSwapKey = (promotionId) => {
    return `promo_swap_${promotionId}`;
};

export const getPromotionSwapData = (promotionId) => {
    try {
        const key = getPromotionSwapKey(promotionId);
        const data = localStorage.getItem(key);
        if (!data) {
            return { removed: [], added: [] };
        }
        return JSON.parse(data);
    } catch (e) {
        return { removed: [], added: [] };
    }
};

export const setPromotionSwapData = (promotionId, data) => {
    try {
        const key = getPromotionSwapKey(promotionId);
        localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
    }
};

export const clearPromotionSwapData = (promotionId) => {
    try {
        const key = getPromotionSwapKey(promotionId);
        localStorage.removeItem(key);
    } catch (e) {
    }
};

